import React from 'react';
export const Beneficios: React.FC = () => {
  const beneficios = [{
    emoji: '✨',
    text: 'Estimula la creatividad'
  }, {
    emoji: '🧠',
    text: 'Favorece la concentración'
  }, {
    emoji: '📵',
    text: 'Reduce el tiempo frente a pantallas'
  }, {
    emoji: '👨‍👩‍👧',
    text: 'Actividad para toda la familia'
  }, {
    emoji: '✈️',
    text: 'Ideal para viajes y vacaciones'
  }, {
    emoji: '⏰',
    text: 'Horas y horas de entretenimiento'
  }];
  return <section className="py-8 px-4 bg-cream" data-id="element-15">
      <div className="max-w-2xl mx-auto" data-id="element-16">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-2" data-id="element-17">
          Más que <span className="text-gold-dark" data-id="element-18">colorear</span>
        </h2>
        <p className="text-center text-textsoft mb-6 text-base font-semibold" data-id="element-19">
          Beneficios que vas a notar desde el primer día.
        </p>

        <div className="bg-white rounded-3xl border-t-[6px] border-gold p-5 shadow-card" data-id="element-20">
          <ul className="divide-y-2 divide-dashed divide-cream-dark" data-id="element-21">
            {beneficios.map((b, idx) => <li key={idx} className="flex items-center gap-3 py-3 first:pt-0 last:pb-0" data-id="element-22">
                <span className="text-2xl flex-shrink-0 leading-none" data-id="element-23">
                  {b.emoji}
                </span>
                <span className="text-violet font-bold text-base sm:text-lg" data-id="element-24">
                  {b.text}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
};